import React, { useId } from 'react';
import { PROJECT_STATUS_FILTERS } from '../../domain/projects';

function ProjectStatusFilter({ selectedStatus, onStatusChange }) {
  const groupName = useId();

  return (
    <div className="chip-choices" role="radiogroup" aria-label="Filtrar por status do projeto">
      {PROJECT_STATUS_FILTERS.map((option) => {
        const selected = option.value === selectedStatus;

        return (
          <label
            key={option.value}
            className={selected ? 'chip-choice is-selected' : 'chip-choice'}
          >
            <input
              className="sr-only"
              type="radio"
              name={groupName}
              value={option.value}
              checked={selected}
              onChange={() => onStatusChange(option.value)}
            />
            {option.label}
          </label>
        );
      })}
    </div>
  );
}

export default ProjectStatusFilter;
